<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card class="text-xs-center">

          <!-- Título da tela -->
          <basic-toolbar :title="'Novo Relatório Técnico de Extensão'"></basic-toolbar>

          <v-card-text>

            <!-- Mensagem informativa -->
            <v-layout row wrap text-xs-left>
              <v-flex xs12>
                <v-alert class="alertaEdicao" dense type="info" color="#00796b" outlined>
                  Em caso de dúvidas ou sugestões entrar em contato pelo e-mail <a
                    href="mailto:suporte.proex@ufes.br">suporte.proex@ufes.br</a>. Já em caso de problemas com o sistema
                  entrar em contato pelo <a href="https://redmine.ufes.br/projects/suporte-projetos-extensao/issues/new"
                    target="_blank">Sistema de Suporte</a>.
                </v-alert>
              </v-flex>
            </v-layout>

            <!-- Título -->
            <v-layout row>
              <v-flex xs12>
                <c-readonly-field class="textoRelatorio" v-if="this.projeto.titulo !== null" label="Título"
                  :value="this.projeto.titulo"></c-readonly-field>
                <c-readonly-field class="textoRelatorio" v-else label="Título" value="-"></c-readonly-field>
              </v-flex>
            </v-layout>

            <!-- Nome do coordenador -->
            <v-layout row>
              <v-flex xs12>
                <c-readonly-field class="textoRelatorio" v-if="this.projeto.nomeCoordenador !== null"
                  label="Nome do coordenador" :value="this.projeto.nomeCoordenador"></c-readonly-field>
                <c-readonly-field class="textoRelatorio" v-else label="Nome do coordenador" value="-"></c-readonly-field>
              </v-flex>
            </v-layout>

            <!-- Número e Tipo -->
            <v-layout row>
              <!-- Número -->
              <v-flex xs6>
                <c-readonly-field class="textoRelatorio" v-if="this.projeto.idProjeto !== null" label="Número"
                  :value="this.projeto.idProjeto"></c-readonly-field>
                <c-readonly-field class="textoRelatorio" v-else label="Número" value="-"></c-readonly-field>
              </v-flex>
              <!-- Tipo -->
              <v-flex xs6>
                <c-readonly-field class="textoRelatorio" v-if="this.projeto.classificacaoSecundaria.descricao !== null"
                  label="Tipo" :value="this.projeto.classificacaoSecundaria.descricao"></c-readonly-field>
                <c-readonly-field class="textoRelatorio" v-else label="Tipo" value="-"></c-readonly-field>
              </v-flex>
            </v-layout>

            <br>

            <v-divider></v-divider>

            <br>

            <v-form v-model="formularioValido" ref="form">

              <!-- Tipo do relatório para cursos/oficinas (39729), cursos (44194), oficinas (44195) e eventos (39730) -->
              <div
                v-if="projeto.classificacaoSecundaria.id === 39729 || projeto.classificacaoSecundaria.id === 44194 || projeto.classificacaoSecundaria.id === 44195 || projeto.classificacaoSecundaria.id === 39730">

                <v-layout row wrap text-xs-left>
                  <v-flex xs12>
                    <v-radio-group v-model="relatorioExtensao.tipoRelatorioTecnicoItem" id="v-radio-group_label"
                      class="v-radio-group_label, item" :mandatory="true" label="Tipo do relatório">
                      <v-radio class="opcaoRadio" :value="3"
                        label="Relatório Final: Deverá ser apresentado no prazo máximo de até 60 dias após a data prevista de conclusão da ação extensionista ou do término das atividades, no caso de encerramento antes do previsto."></v-radio>
                    </v-radio-group>
                  </v-flex>
                </v-layout>

                <div v-if="relatorioHabilitadoAcaoRegistroTardio() === false">

                  <!-- Houve mudança nas datas de início e/ou de conclusão da ação de extensão? -->
                  <v-layout row wrap text-xs-left>
                    <v-flex xs12>
                      <v-radio-group v-model="relatorioExtensao.mudancaDatasAcao" id="v-radio-group_label"
                        class="v-radio-group_label, item" :mandatory="true"
                        label="Houve mudança nas datas de início e/ou de conclusão da ação de extensão?">
                        <v-radio class="opcaoRadio" label="Sim" :value="true"></v-radio>
                        <v-radio class="opcaoRadio" label="Não" :value="false"></v-radio>
                      </v-radio-group>
                    </v-flex>
                  </v-layout>

                  <!-- Confirme as datas de início e de conclusão da ação de extensão -->
                  <v-layout v-if="relatorioExtensao.mudancaDatasAcao === true" row wrap text-xs-left>
                    <v-flex xs12>
                      <br>
                      <label class="textoConfirmaMudancaDatas">Confirme as datas de início e de conclusão da ação de
                        extensão</label>
                    </v-flex>
                  </v-layout>

                  <!-- Data de início e Data de conclusão -->
                  <v-layout v-if="relatorioExtensao.mudancaDatasAcao === true" row wrap text-xs-left>

                    <!-- Data de início -->
                    <v-flex xs12 sm3>
                      <v-text-field label="Data de início" v-model="relatorioExtensao.dataInicio" type="date" required
                        prepend-icon="event"></v-text-field>
                    </v-flex>

                    <v-spacer></v-spacer>

                    <!-- Data de conclusão -->
                    <v-flex xs12 sm3>
                      <v-text-field label="Data de conclusão" v-model="relatorioExtensao.dataConclusao" type="date"
                        required prepend-icon="event"></v-text-field>
                    </v-flex>

                    <v-spacer></v-spacer>

                  </v-layout>

                  <!-- Justifique a mudança -->
                  <v-layout v-if="relatorioExtensao.mudancaDatasAcao === true" row wrap text-xs-left>
                    <v-flex xs12>
                      <br>
                      <label class="item">Justifique a mudança</label>
                      <v-textarea v-model="relatorioExtensao.justificativaMudancaDatasAcao" rows="1" auto-grow
                        counter="500" :rules="[...obrigatorio, ...rules500]">
                      </v-textarea>
                    </v-flex>
                  </v-layout>

                </div>

              </div>

              <!-- Tipo do relatório para programas (39733), projetos (39734) e prestações de serviço (39731) -->
              <div
                v-if="projeto.classificacaoSecundaria.id === 39733 || projeto.classificacaoSecundaria.id === 39734 || projeto.classificacaoSecundaria.id === 39731">

                <v-layout row wrap text-xs-left>
                  <v-flex xs12>
                    <v-radio-group v-model="relatorioExtensao.tipoRelatorioTecnicoItem" id="v-radio-group_label"
                      class="v-radio-group_label, item" :mandatory="true" label="Tipo do relatório">
                      <!-- <v-radio :value="1" label="Relatório Parcial: Deverá ser apresentado a cada 12 meses de atividade e encaminhado à ProEx no prazo máximo de 60 dias após o término do interstício."></v-radio> -->
                      <v-radio :value="2"
                        label="Relatório Parcial com Renovação: Deverá ser apresentado no prazo máximo de até 60 dias do último interstício da ação indicando o período de renovação."></v-radio>
                      <!-- <v-radio :value="3" label="Relatório Final: Deverá ser apresentado no prazo máximo de até 60 dias após a data prevista de conclusão da ação extensionista ou do término das atividades, no caso de encerramento antes do previsto." ></v-radio> -->
                    </v-radio-group>
                  </v-flex>
                </v-layout>

                <!-- Mensagem exibida caso o usuário selecione relatório com renovação -->
                <div v-if="relatorioExtensao.tipoRelatorioTecnicoItem === 2">
                  <v-layout row wrap text-xs-left>
                    <v-flex xs12>
                      <label>*Em caso de "Relatório Parcial com Renovação", é necessária a atualização das atividades e
                        outras informações relativas ao novo interstício de execução da ação.</label>
                    </v-flex>
                  </v-layout>
                  <br>
                </div>

                <!-- Informe o período a que se refere o relatório -->
                <v-layout row wrap text-xs-left>
                  <v-flex xs12>
                    <br>
                    <label class="textoInformaPeriodoRelatorio">Informe o período a que se refere o relatório</label>
                  </v-flex>
                </v-layout>

                <!-- Início e Fim -->
                <v-layout row wrap text-xs-left>

                  <!-- Início -->
                  <v-flex xs12 sm3>
                    <v-text-field label="Início" v-model="relatorioExtensao.dataInicial" type="date" required
                      prepend-icon="event"></v-text-field>
                  </v-flex>

                  <v-spacer></v-spacer>

                  <!-- Fim -->
                  <v-flex xs12 sm3>
                    <v-text-field label="Fim" v-model="relatorioExtensao.dataFinal" type="date" required
                      prepend-icon="event"></v-text-field>
                  </v-flex>

                  <v-spacer></v-spacer>

                </v-layout>

              </div>

            </v-form>

            <br>

            <v-divider></v-divider>

            <v-card-actions>

              <!-- Botão "Cancelar" -->
              <v-btn color="primary" text @click="$router.go(-1)">Cancelar</v-btn>

              <v-spacer></v-spacer>

              <!-- Botão "Adicionar" -->
              <v-btn color="primary" text @click="novoRelatorioTecnicoExtensao"
                :disabled="!formularioValido">Adicionar</v-btn>

            </v-card-actions>

          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ReadonlyField from '@/components/c-readonly-field'
import BasicToolbar from '@/components/toolbars/basic-toolbar'
import dates from '@/utils/dates'
import projetos from '@/utils/projetos'
import { mapActions, mapGetters } from 'vuex'

export default {
  props: ['idProjeto', 'idRelatorioExtensao'],
  data: () => ({
    dates: dates,
    projeto: {
      classificacoesPrimariaSecundaria: [{}, {}]
    },
    relatorioExtensao: {
      mudancaDatasAcao: false,
      dataInicio: null,
      dataConclusao: null

    },
    tipoRelatorioTecnicoItemInicial: 0,
    obrigatorio: [v => !!v || 'Este campo é obrigatório'],
    rules500: [
      (input) => input.length <= 500 || 'Este campo não pode possuir mais que 500 caracteres'
    ],
    formularioValido: false
  }),
  computed: {
    ...mapGetters('auth', ['administrador']),
    cursoOuEvento: function () {
      return (this.projeto.classificacaoSecundaria.id === 39729 || this.projeto.classificacaoSecundaria.id === 44194 || this.projeto.classificacaoSecundaria.id === 44195 || this.projeto.classificacaoSecundaria.id === 39730)
    }
  },
  methods: {
    ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
    // Verifica se o preenchimento do relatório final está habilitado para ações de extensão com registro tardio.
    relatorioHabilitadoAcaoRegistroTardio: function () {
      if (this.projeto.relatorioFinalHabilitado === true) {
        return true
      } else {
        return false
      }
    },
    // Cria um novo relatório técnico.
    novoRelatorioTecnicoExtensao: function () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Adicionando relatório técnico de extensão.' })
      projetos.postRelatorioExtensao(this.idProjeto, this.relatorioExtensao)
        .then(response => {
          this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem })
          this.$router.push({ name: 'RelatoriosProjeto', params: { idProjeto: this.idProjeto } })
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
          this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem })
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Adicionando relatório técnico de extensão.' })
        })
    }
  },
  mounted: function () {
    // Carrega informações da ação de extensão.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ação de extensão.' })
    projetos.getProjeto(this.idProjeto)
      .then(response => {
        this.projeto = response.data
        this.relatorioExtensao.dataInicio = this.projeto.dataInicio
        this.relatorioExtensao.dataConclusao = this.projeto.dataConclusao
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ação de extensão.' })
      })
  },
  components: {
    'basic-toolbar': BasicToolbar,
    'c-readonly-field': ReadonlyField
  }
}
</script>

<style lang="css" scoped>
.v-text-field>>>label {
  font-size: 14pt;
}

.v-radio>>>label {
  font-size: 1.0em;
}

.alertaEdicao {
  margin: 1.6em 0 2.0em 0;
  font-size: 1.10em
}

.alertaEdicao a {
  text-decoration: underline;
}

.alerta {
  margin: 1.6em 0 2.0em 0;
  font-size: 1.10em;
  text-align: center;
}

.textoConfirmaMudancaDatas {
  font-weight: bold;
  font-size: 1.25em;
}

.textoInformaPeriodoRelatorio {
  font-weight: bold;
  font-size: 1.25em;
}
</style>

<style lang="css">
#v-radio-group_label {
  font-size: 1.0em;
}

#v-radio-group_label_9 {
  font-size: 1.05em;
}

.v-checkbox_label {
  font-size: 0.95em;
}

th.objetivoEspecifico,
th.resultados {
  width: 50%
}

.box {
  text-align: center;
  margin-top: 2em;
  margin-bottom: 2em;
}

.item {
  font-weight: bold;
  font-size: 1.25em;
}

.textoRelatorio {
  font-size: 1.25em;
}

.opcaoRadio {
  font-weight: normal;
}

.tabela {
  margin-top: 15px;
  margin-bottom: 20px;
}

.tabela th {
  font-weight: bold !important;
  font-size: 1.1em !important;
}

.tabela td {
  font-size: 1.1em !important;
}
</style>



// WEBPACK FOOTER //
// novo-relatorio-tecnico.vue?7826ff6c